import {useState} from 'react';
import {useQuery} from '@apollo/client';
import {Table, Pagination, Tag} from 'antd';
import {toast} from 'react-toastify';
import moment from 'moment';
import UserLink from 'components/userLink/UserLink';
import {GET_SIMULATOR_SUBSCRIPTIONS} from './resolvers';
import {SubscriptionsFilter} from './SubscriptionsFilter';
import styles from './simulator.module.scss';
import filterIcon from 'icons/filter.svg';
import {Form} from 'antd';

export const Subscriptions = ({type = 'SUBSCRIPTION'}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [form] = Form.useForm();

  const {data, loading, refetch} = useQuery(GET_SIMULATOR_SUBSCRIPTIONS, {
    variables: {
      input: {
        page: currentPage,
        limit,
        subscriptionType: type,
      },
    },
    fetchPolicy: 'network-only',
    onError: error => toast.error(error.message),
  });

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setLimit(pageSize);

    // Include current filters when changing page
    const currentFilters = form.getFieldsValue();
    handleFilter(currentFilters, page, pageSize);
  };

  const handleFilter = (values, page = 1, pageSize = limit) => {
    if (page === 1) {
      setCurrentPage(1);
    }

    const filters = {};
    if (values.cycle) filters.cycle = values.cycle;
    if (values.channel) filters.channel = values.channel;
    if (values.planType) filters.planType = values.planType;
    if (values.planType) filters.planType = values.planType;
    if (type) filters.subscriptionType = type;
    if (values.active !== undefined) filters.active = values.active;

    refetch({
      input: {
        page,
        limit: pageSize,
        ...filters,
      },
    });

    if (openFilterModal) {
      setOpenFilterModal(false);
    }
  };

  const columns = [
    {
      title: 'User',
      dataIndex: 'user',
      key: 'user',
      render: user => (
        <div>
          <div>
            <UserLink userId={user?.id}>
              {user?.firstName} {user?.lastName}
            </UserLink>
          </div>
          <div style={{fontSize: '12px', color: '#888'}}>{user?.email}</div>
        </div>
      ),
    },
    {
      title: 'Plan Type',
      dataIndex: 'planType',
      key: 'planType',
      render: text => (
        <Tag color={text === 'PREMIUM' ? 'gold' : 'blue'}>{text}</Tag>
      ),
    },
    {
      title: 'Subscription Type',
      dataIndex: 'subscriptionType',
      key: 'subscriptionType',
      render: text => <Tag>{text}</Tag>,
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (text, record) => `${record.currency} ${text}`,
    },
    {
      title: 'Cycle',
      dataIndex: 'cycle',
      key: 'cycle',
      render: text => <Tag>{text}</Tag>,
    },
    {
      title: 'Status',
      dataIndex: 'active',
      key: 'active',
      render: active => (
        <Tag color={active ? 'green' : 'red'}>
          {active ? 'Active' : 'Inactive'}
        </Tag>
      ),
    },
    {
      title: 'Channel',
      dataIndex: 'channel',
      key: 'channel',
      render: text => <Tag>{text}</Tag>,
    },
    {
      title: 'Started At',
      dataIndex: 'startedAt',
      key: 'startedAt',
      render: text => moment(text).format('M/D/YY hh:mm a'),
    },
    {
      title: 'Expires At',
      dataIndex: 'expiresAt',
      key: 'expiresAt',
      render: text => (text ? moment(text).format('M/D/YY hh:mm a') : 'N/A'),
    },
  ];

  const totalPages = data?.getSimulatorSubscriptions?.pagination?.total || 0;

  return (
    <div className={styles['form-container']}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
        }}>
        <h2 className={styles.title}>
          {type === 'VIRTUALMONEY' ? 'Virtual Money' : 'Subscriptions'}
        </h2>
        <div style={{position: 'relative'}}>
          <div
            onClick={() => setOpenFilterModal(!openFilterModal)}
            className={styles.filter}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              padding: '8px 16px',
              border: '1px solid #ded7f6',
              borderRadius: '32px',
            }}>
            <h2
              style={{
                fontSize: '14px',
                margin: 0,
                fontWeight: 500,
                color: '#16054e',
              }}>
              Filter
            </h2>
            <img src={filterIcon} alt="" />
          </div>
          {openFilterModal && (
            <div
              style={{
                position: 'absolute',
                right: 0,
                top: '50px',
                zIndex: 1000,
              }}>
              <SubscriptionsFilter
                form={form}
                handleFilter={handleFilter}
                handleClose={() => setOpenFilterModal(false)}
              />
            </div>
          )}
        </div>
      </div>

      <div className={styles.tableContainer}>
        <Table
          dataSource={data?.getSimulatorSubscriptions?.data || []}
          columns={columns}
          pagination={false}
          loading={loading}
          rowKey="id"
          className="antd-table"
        />
        <Pagination
          showQuickJumper
          current={currentPage}
          showSizeChanger
          onChange={handlePageChange}
          className="ant-table-pagination"
          total={totalPages}
          pageSize={limit}
        />
      </div>
    </div>
  );
};
